import type {
  AssignEventStaffRequest,
  EventStaffAssignmentResponse,
  ListEventStaffResponse,
} from '@jq4race/shared';

import { request } from './client.js';

// ── Event staff (S3: assign/unassign/list valets on an event) ──────────────

export async function listEventStaff(eventId: string): Promise<ListEventStaffResponse> {
  return request<ListEventStaffResponse>(`/admin/events/${encodeURIComponent(eventId)}/staff`, {
    method: 'GET',
  });
}

export async function assignEventStaff(
  eventId: string,
  input: AssignEventStaffRequest,
): Promise<EventStaffAssignmentResponse> {
  return request<EventStaffAssignmentResponse>(
    `/admin/events/${encodeURIComponent(eventId)}/staff`,
    { method: 'POST', body: input },
  );
}

export async function unassignEventStaff(eventId: string, userId: string): Promise<void> {
  return request<void>(
    `/admin/events/${encodeURIComponent(eventId)}/staff/${encodeURIComponent(userId)}`,
    { method: 'DELETE' },
  );
}
